/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Pending_AgeInputs */

const en_orders_pending_age = /** @type {(inputs: Orders_Pending_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending Age`)
};

const es_orders_pending_age = /** @type {(inputs: Orders_Pending_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antiguedad pendiente`)
};

/**
* | output |
* | --- |
* | "Pending Age" |
*
* @param {Orders_Pending_AgeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_pending_age = /** @type {((inputs?: Orders_Pending_AgeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Pending_AgeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_pending_age(inputs)
	return es_orders_pending_age(inputs)
});